import {   
    Link, 
  } 
    from 'react-router-dom';

import styles from './Navbar.module.scss';
import { HeaderLogo } from '../../widgets/Header/ui/HeaderLogo/HeaderLogo';
import { burgerIcon } from '../../shared/assets/svg/burgerIcon';
import { closeIcon } from '../../shared/assets/svg/closeIcon';
import { useState } from 'react';
import { Button } from "../../shared/ui/Button/Button";
import { useScrollLogo } from '../../shared/hooks/useScrollLogo';
import { bookingIcon } from '../../shared/assets/svg/bookingIcon';



  const Navbar = () => {
    

    const { isShow } = useScrollLogo();
    const [isOpen, setOpen] = useState();
    const [openService, setOpenService] = useState();



    const handleService = () => { 
      setOpenService(!openService);
      }
    const handleClik = () => { 
      setOpen(!isOpen);
      setOpenService();   
      }
    
    return (
      <div>
        <div className={styles.content}>
            <div className={styles.menu}>  
              {!isShow &&
                <HeaderLogo/>
              }
              
              <div className={styles.burgerMenu}>
                  <Button className={styles.button}>
                      <Link to='tel:+79288408020' 
                      className={styles.linkHeader}>
                          +7 928 840 80 20 
                      </Link>
                      <Link to='tel:+79288408020' 
                      className={styles.bookingIcon}>
                        {bookingIcon()}
                      </Link>
                  </Button>

                    <Button className={styles.burger}
                            onClick={handleClik}
                        >
                            {isOpen ? closeIcon() : burgerIcon()}                    
                    </Button>
              </div>

              <nav  className={`${styles.nav} ${isOpen ? styles.open : ''}`}>              
                <Link onClick={handleClik} to="/" children="MainPage" className={`link ${styles.link__main}`}>
                    главная
                </Link>

                <div className = {styles.service}>        
                    <button onClick={handleService} className={`link ${styles.link}`}>услуги</button> 

                  {
                    openService &&
                      <div  className = {`${styles.service__menu} ${openService ? styles.active : ''}`}>
                        <div className = {styles.service__list}>
                            <Link onClick={handleClik} to="/hygiene" className={`services ${styles.service__item}`}>
                              Профилактика и эстетика 
                            </Link>
                            <Link onClick={handleClik} to="/endodontics" className={`services ${styles.service__item}`}>
                              Эндодонтия
                            </Link>
                            <Link onClick={handleClik} to="/prosthetics" className={`services ${styles.service__item}`}>
                              Протезирование
                            </Link>
                            <Link onClick={handleClik} to="/implant" className={`services ${styles.service__item}`}>
                              Хирургия и имплантация
                            </Link>
                        </div>
                      </div>
                  }
                </div>
                
                <Link onClick={handleClik} to="/about" className={`link ${styles.link}`}>
                  о нас
                </Link>
                <Link onClick={handleClik} to="/contact" className={`link ${styles.link}`}>
                  Контакты
                </Link>
              </nav>
            </div>
        </div>
    
        </div>
    );
  }
  
  export default Navbar;